module.exports = __webpack_public_path__ + "e9ae41f26dac6686aa14f6c7f0342bb5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-4.png
// module id = 1804
// module chunks = 0